export default "__VITE_ASSET__B1empoBi__"